import _isEmpty from 'lodash/isEmpty';
import { isMultiStopDelivery } from './order';
import { isDev } from '../common/utils/environment-util';

export const MAX_ORDERS_GUEST_ORDER_TRACKING = 10;

const getGuestOrderTrackingURL = () =>
  isDev() ? 'https://express.stg-myteksi.com/track/orders' : '/track/orders';

export const redirectGuestOrderTracking = orderIDs => {
  if (!_isEmpty(orderIDs)) {
    window.open(
      `${getGuestOrderTrackingURL()}?src=webbooking&ids=${orderIDs.join(',')}`,
    );
  }
};

export const extractOrderIDs = bookings => {
  const orderIDs = [];
  if (_isEmpty(bookings)) {
    return orderIDs;
  }

  bookings.forEach(order => {
    if (isMultiStopDelivery(order)) {
      orderIDs.push(...order.steps.slice(1).map(step => step.orderID));
    } else {
      orderIDs.push(order.orderID);
    }
  });
  return orderIDs.filter(orderID => !!orderID);
};
